import React from 'react'
import {keyframes} from '@emotion/react'
import styled from '@emotion/styled'

import {iconsList} from '@vio/atlas/Icon'

// Values are based on the Figma design
export const ILLUSTRATION_HEIGHT = {
  mobile: 32,
  desktop: 48
}

// Illustration values are based on the Figma design
const SWING_MS = 300
const SWING_DEG = 21.23
const SWING_X_UNITS = -2.26
const SWING_Y_UNITS = -0.91
const VIEWBOX_HEIGHT = 32
const CYCLE_MS = 2000
const OUT_PCT = (SWING_MS / CYCLE_MS) * 100
const BACK_PCT = OUT_PCT * 2

const {AuthIllustration} = iconsList

const swing = keyframes`
  0% { transform: rotate(0deg) translate(0, 0); }
  ${OUT_PCT}% {
    transform: rotate(${SWING_DEG}deg)
      translate(
        calc(var(--swing-unit) * ${SWING_X_UNITS}),
        calc(var(--swing-unit) * ${SWING_Y_UNITS})
      );
  }
  ${BACK_PCT}%,
  100% { transform: rotate(0deg) translate(0, 0); }
`

const Swinging = styled.div<{illustrationHeight: number}>`
  display: inline-flex;
  --swing-unit: ${({illustrationHeight}) =>
    illustrationHeight / VIEWBOX_HEIGHT}px;
  animation: ${swing} ${CYCLE_MS}ms ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const AnimatedAuthIllustration = ({height}: {height: number}) => (
  <Swinging illustrationHeight={height} aria-hidden="true">
    <AuthIllustration size={height} />
  </Swinging>
)
